import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomNavbar from './Navbar/Navbar';
import '../assets/css/styles.css';

const ListaHojasVida = () => {
    const [hojasVida, setHojasVida] = useState([]);
    const [hojasVidaFiltradas, setHojasVidaFiltradas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [hojasCompletas, setHojasCompletas] = useState({});
    const [expandedId, setExpandedId] = useState(null);
    const [estadosCargando, setEstadosCargando] = useState({});

    const [filtros, setFiltros] = useState({
        nombreCompleto: '',
        tituloCarrera: '',
        empresa: '',
        puestoCargo: '',
        fechaInicio: '',
        fechaFin: ''
    });

    const [puestos, setPuestos] = useState([]);
    const [puestosLoading, setPuestosLoading] = useState(true);

    useEffect(() => {
        const fetchPuestos = async () => {
            try {
                setPuestosLoading(true);
                const response = await fetch('https://apicv.conduto.com.ec/api/puestos');
                if (!response.ok) throw new Error('Error al cargar puestos');
                const result = await response.json();
                if (result.success) {
                    setPuestos(result.data || []);
                } else {
                    setPuestos([]);
                }
            } catch (err) {
                console.error('Error cargando puestos:', err);
                setPuestos([]);
            } finally {
                setPuestosLoading(false);
            }
        };

        fetchPuestos();
    }, []);

    useEffect(() => {
        cargarHojasVida();
    }, []);

    useEffect(() => {
        aplicarFiltros();
    }, [filtros, hojasVida]);

    const cargarHojasVida = async () => {
        try {
            setLoading(true);
            const response = await fetch('https://apicv.conduto.com.ec/api/hojas-vida');

            if (!response.ok) {
                throw new Error('Error al cargar los datos');
            }

            const result = await response.json();

            if (result.success) {
                setHojasVida(result.data);
                setHojasVidaFiltradas(result.data);
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            console.error('Error:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const cargarHojaCompleta = async (id) => {
        try {
            const response = await fetch(`https://apicv.conduto.com.ec/api/hoja-vida/${id}`);

            if (!response.ok) {
                throw new Error('Error al cargar los detalles');
            }

            const result = await response.json();

            if (result.success) {
                setHojasCompletas(prev => ({
                    ...prev,
                    [id]: result.data
                }));
                return result.data;
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            console.error('Error al cargar detalles:', error);
            throw error;
        }
    };

    const actualizarEstadoSeleccion = async (id, nuevoEstado) => {
        try {
            setEstadosCargando(prev => ({ ...prev, [id]: true }));

            const response = await fetch(`https://apicv.conduto.com.ec/api/hoja-vida/${id}/estado-seleccion`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ estado_seleccion: nuevoEstado })
            });

            if (!response.ok) {
                throw new Error('Error al actualizar el estado');
            }

            const result = await response.json();

            if (result.success) {
                setHojasVida(prev => prev.map(hoja =>
                    hoja.id === id ? { ...hoja, estado_seleccion: nuevoEstado } : hoja
                ));

                setHojasCompletas(prev => {
                    if (prev[id]) {
                        return {
                            ...prev,
                            [id]: { ...prev[id], estado_seleccion: nuevoEstado }
                        };
                    }
                    return prev;
                });
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            console.error('Error al actualizar estado:', error);
            alert(`Error al actualizar estado: ${error.message}`);
        } finally {
            setEstadosCargando(prev => ({ ...prev, [id]: false }));
        }
    };

    useEffect(() => {
        if (!hojasVidaFiltradas || hojasVidaFiltradas.length === 0) return;

        const cargarTodasExperiencias = async () => {
            for (const hoja of hojasVidaFiltradas) {
                if (!hojasCompletas[hoja.id]) {
                    try {
                        await cargarHojaCompleta(hoja.id);
                    } catch (err) {
                        console.error('Error cargando experiencias para id', hoja.id, err);
                    }
                }
            }
        };

        cargarTodasExperiencias();
    }, [hojasVidaFiltradas]);

    const formatearSoloFecha = (fecha) => {
        if (!fecha) return 'No especificada';
        const d = new Date(fecha);
        return d.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const toggleExpandir = async (id) => {
        if (expandedId === id) {
            setExpandedId(null);
        } else {
            setExpandedId(id);
            if (!hojasCompletas[id]) {
                try {
                    await cargarHojaCompleta(id);
                } catch (error) {
                    setError(`Error al cargar detalles: ${error.message}`);
                }
            }
        }
    };

    const descargarCV = (filename) => {
        if (filename) {
            window.open(`https://apicv.conduto.com.ec/api/descargar-cv/${filename}`, '_blank');
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return 'No especificada';
        const d = new Date(fecha);
        const f = d.toLocaleDateString('es-ES');
        const h = d.toLocaleTimeString('es-ES', { hour12: false });
        return `${f} - ${h}`;
    };

    const obtenerIniciales = (nombre, apellido) => {
        const primeraLetraNombre = nombre ? nombre.charAt(0) : '';
        const primeraLetraApellido = apellido ? apellido.charAt(0) : '';
        return (primeraLetraNombre + primeraLetraApellido).toUpperCase();
    };

    const handleFiltroChange = (e) => {
        const { name, value } = e.target;
        setFiltros(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const limpiarFiltros = () => {
        setFiltros({
            nombreCompleto: '',
            tituloCarrera: '',
            empresa: '',
            puestoCargo: '',
            fechaInicio: '',
            fechaFin: ''
        });
    };

    const aplicarFiltros = () => {
        let filtradas = hojasVida;

        if (filtros.nombreCompleto) {
            filtradas = filtradas.filter(hoja => {
                const nombreCompleto = `${hoja.nombre || ''} ${hoja.apellido || ''}`.toLowerCase();
                return nombreCompleto.includes(filtros.nombreCompleto.toLowerCase());
            });
        }

        if (filtros.tituloCarrera) {
            filtradas = filtradas.filter(hoja => {
                const hojaCompleta = hojasCompletas[hoja.id];
                if (hojaCompleta && hojaCompleta.formacionesAcademicas) {
                    return hojaCompleta.formacionesAcademicas.some(formacion =>
                        formacion.titulo?.toLowerCase().includes(filtros.tituloCarrera.toLowerCase()) ||
                        formacion.area_estudio?.toLowerCase().includes(filtros.tituloCarrera.toLowerCase())
                    );
                }
                return false;
            });
        }

        if (filtros.empresa) {
            filtradas = filtradas.filter(hoja => {
                const hojaCompleta = hojasCompletas[hoja.id];
                if (hojaCompleta && hojaCompleta.experiencias) {
                    return hojaCompleta.experiencias.some(experiencia =>
                        experiencia.empresa?.toLowerCase().includes(filtros.empresa.toLowerCase())
                    );
                }
                return false;
            });
        }

        if (filtros.puestoCargo) {
            filtradas = filtradas.filter(hoja => {
                const hojaCompleta = hojasCompletas[hoja.id];
                if (hojaCompleta && hojaCompleta.experiencias) {
                    return hojaCompleta.experiencias.some(experiencia =>
                        (experiencia.puesto && experiencia.puesto.toLowerCase().includes(filtros.puestoCargo.toLowerCase())) ||
                        (experiencia.otro_puesto && experiencia.otro_puesto.toLowerCase().includes(filtros.puestoCargo.toLowerCase()))
                    );
                }
                return false;
            });
        }

        if (filtros.fechaInicio || filtros.fechaFin) {
            filtradas = filtradas.filter(hoja => {
                const fechaHoja = new Date(hoja.fecha_creacion);
                let cumpleInicio = true;
                let cumpleFin = true;

                if (filtros.fechaInicio) {
                    const fechaInicio = new Date(filtros.fechaInicio);
                    fechaInicio.setHours(0, 0, 0, 0);
                    cumpleInicio = fechaHoja >= fechaInicio;
                }

                if (filtros.fechaFin) {
                    const fechaFin = new Date(filtros.fechaFin);
                    fechaFin.setHours(23, 59, 59, 999);
                    cumpleFin = fechaHoja <= fechaFin;
                }

                return cumpleInicio && cumpleFin;
            });
        }

        setHojasVidaFiltradas(filtradas);
    };

    if (loading) {
        return (
            <div className="container mt-4">
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{ color: "#004892" }} role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                </div>
                <p className="text-center mt-2">Cargando hojas de vida...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mt-4">
                <div className="alert alert-danger" role="alert">
                    <h4 className="alert-heading">Error</h4>
                    <p>{error}</p>
                    <button className="btn btn-primary" onClick={cargarHojasVida}>
                        Reintentar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
            <CustomNavbar />
            <div className="container mt-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h1 className="mb-0">Lista de Hojas de Vida</h1>
                    </div>
                    <span className="badge bg-primary fs-6">
                        {hojasVidaFiltradas.length} de {hojasVida.length} registros
                    </span>
                </div>

                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">
                        <i className="bi bi-funnel me-2"></i>
                        Filtros de Búsqueda
                    </h5>
                    <div className="row g-3">
                        <div className="col-md-3">
                            <label htmlFor="nombreCompleto" className="form-label">Nombre Completo</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nombreCompleto"
                                name="nombreCompleto"
                                value={filtros.nombreCompleto}
                                onChange={handleFiltroChange}
                                placeholder="Buscar por nombre..."
                            />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="tituloCarrera" className="form-label">Título / Carrera</label>
                            <input
                                type="text"
                                className="form-control"
                                id="tituloCarrera"
                                name="tituloCarrera"
                                value={filtros.tituloCarrera}
                                onChange={handleFiltroChange}
                                placeholder="Filtrar por título..."
                            />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="empresa" className="form-label">Empresa</label>
                            <input
                                type="text"
                                className="form-control"
                                id="empresa"
                                name="empresa"
                                value={filtros.empresa}
                                onChange={handleFiltroChange}
                                placeholder="Filtrar por empresa..."
                            />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="puestoCargo" className="form-label">Puesto / Cargo</label>
                            {puestosLoading ? (
                                <div className="form-control">
                                    <small>Cargando puestos...</small>
                                </div>
                            ) : (
                                <select
                                    id="puestoCargo"
                                    name="puestoCargo"
                                    className="form-select"
                                    value={filtros.puestoCargo}
                                    onChange={handleFiltroChange}
                                >
                                    <option value="">Todos los puestos</option>
                                    {puestos.map(puesto => {
                                        const label = puesto.nombre || puesto.puesto || puesto.name || String(puesto);
                                        const value = label;
                                        return (
                                            <option key={puesto.id || value} value={value}>{label}</option>
                                        );
                                    })}
                                </select>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label className="form-label">Rango de Fechas de Registro</label>
                            <div className="row g-2">
                                <div className="col">
                                    <div className="input-group">
                                        <span className="input-group-text">
                                            <i className="bi bi-calendar"></i>
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="fechaInicio"
                                            value={filtros.fechaInicio}
                                            onChange={handleFiltroChange}
                                            placeholder="Desde"
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="input-group">
                                        <span className="input-group-text">
                                            <i className="bi bi-calendar"></i>
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="fechaFin"
                                            value={filtros.fechaFin}
                                            onChange={handleFiltroChange}
                                            placeholder="Hasta"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 d-flex align-items-end">
                            <button
                                className="btn btn-outline-secondary me-2"
                                onClick={limpiarFiltros}
                            >
                                <i className="bi bi-arrow-clockwise me-2"></i>
                                Limpiar Filtros
                            </button>
                        </div>
                    </div>
                </div>

                <div>
                    {hojasVidaFiltradas.length === 0 ? (
                        <div className="text-center py-4 border rounded">
                            <i className="bi bi-folder-x display-1 text-muted"></i>
                            <h4 className="mt-3 text-muted">No hay hojas de vida que coincidan con los filtros</h4>
                            <p className="text-muted">Intenta ajustar los criterios de búsqueda.</p>
                            <button
                                className="btn btn-primary"
                                onClick={limpiarFiltros}
                            >
                                Limpiar filtros
                            </button>
                        </div>
                    ) : (
                        <div className="list-group">
                            {hojasVidaFiltradas.map((hoja) => {
                                const hojaCompleta = hojasCompletas[hoja.id];
                                const estaExpandida = expandedId === hoja.id;
                                const esDeConduto = hoja.trabajado_conduto === 'si';

                                return (
                                    <div key={hoja.id} className="list-group-item border rounded mb-2">
                                        <div
                                            className="d-flex justify-content-between align-items-center cursor-pointer"
                                            onClick={() => toggleExpandir(hoja.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                                                    style={{ width: '50px', height: '50px' }}>
                                                    <span className="fw-bold">
                                                        {obtenerIniciales(hoja.nombre, hoja.apellido)}
                                                    </span>
                                                </div>
                                                <div>
                                                    <h5 className="mb-1">
                                                        {hoja.nombre} {hoja.apellido}
                                                    </h5>
                                                    <p className="mb-1 text-muted">
                                                        <strong>Cédula:</strong> {hoja.cedula} |
                                                        <strong> Email:</strong> {hoja.email} |
                                                        <strong> Teléfono:</strong> {hoja.telefono}
                                                    </p>
                                                    <small className="text-muted">
                                                        <strong>Formaciones:</strong> {hoja.total_formaciones} |
                                                        <strong> Idiomas:</strong> {hoja.total_idiomas} |
                                                        <strong> Experiencias:</strong> {hoja.total_experiencias} |
                                                        <strong> ¿Trabajó en Conduto antes?:</strong> {esDeConduto ? 'SÍ' : 'NO'}
                                                        {hojaCompleta && hojaCompleta.experiencias && hojaCompleta.experiencias.length > 0 ? (
                                                            <div className="small mt-1">
                                                                {hojaCompleta.experiencias.map(exp => (
                                                                    <div key={exp.id}>
                                                                        {exp.empresa} / {exp.puesto === "Otros" ? exp.otro_puesto : exp.puesto}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (!hojaCompleta ? (
                                                            <span className="text-muted ms-2"> Cargando experiencias...</span>
                                                        ) : (
                                                            <span className="text-muted ms-2"> Sin experiencias</span>
                                                        ))}
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <small className="text-muted">
                                                        Registrado: {formatearFecha(hoja.fecha_creacion)}
                                                    </small>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-end">
                                                    <small className="text-muted me-2">Estado:</small>
                                                    <select
                                                        className="form-select form-select-sm estado-select"
                                                        style={{
                                                            width: '120px',
                                                            backgroundColor:
                                                                hoja.estado_seleccion === 'Revisado'
                                                                    ? '#008848'
                                                                    : hoja.estado_seleccion === 'No apto'
                                                                        ? '#ce0015'
                                                                        : '#F3F5FA',

                                                            color:
                                                                hoja.estado_seleccion === 'Revisado' ||
                                                                    hoja.estado_seleccion === 'No apto'
                                                                    ? '#ffffff'
                                                                    : '#003D73',

                                                            borderColor: 'transparent'
                                                        }}
                                                        value={hoja.estado_seleccion || 'Seleccionar'}
                                                        onChange={(e) => actualizarEstadoSeleccion(hoja.id, e.target.value)}
                                                        disabled={estadosCargando[hoja.id]}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <option value="Nuevo">Nuevo</option>
                                                        <option value="Revisado">Revisado</option>
                                                        <option value="No apto">No apto</option>
                                                    </select>

                                                    {estadosCargando[hoja.id] && (
                                                        <div className="spinner-border spinner-border-sm ms-2" role="status">
                                                            <span className="visually-hidden">Actualizando...</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <br />
                                            </div>
                                        </div>
                                        <div
                                            className="d-flex justify-content-center"
                                            style={{
                                                cursor: 'pointer',
                                                color: '#000'
                                            }}
                                            onClick={() => toggleExpandir(hoja.id)}
                                        >
                                            <i
                                                className={`bi ${estaExpandida ? 'bi-chevron-up' : 'bi-chevron-down'}`}
                                                style={{
                                                    fontSize: '22px',
                                                    fontWeight: 'bold'
                                                }}
                                            ></i>
                                        </div>


                                        {estaExpandida && hojaCompleta && (
                                            <div className="mt-3 p-3 border rounded bg-light">
                                                <div className="mb-4">
                                                    <h5 className="border-bottom pb-2" style={{ color: "#004892" }}>
                                                        <i className="bi bi-person me-2"></i>
                                                        Datos Personales
                                                    </h5>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <p><strong>Nombre completo:</strong> {hojaCompleta.nombre} {hojaCompleta.apellido}</p>
                                                            <p><strong>Cédula:</strong> {hojaCompleta.cedula}</p>
                                                            <p><strong>Nacionalidad:</strong> {hojaCompleta.nacionalidad}</p>
                                                            <p><strong>Fecha de nacimiento:</strong> {formatearSoloFecha(hojaCompleta.fecha_nacimiento)}</p>
                                                            <p><strong>Estado civil:</strong> {hojaCompleta.estado_civil}</p>
                                                            <p><strong>Género:</strong> {hojaCompleta.genero}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p><strong>Teléfono:</strong> {hojaCompleta.telefono}</p>
                                                            <p><strong>Email:</strong> {hojaCompleta.email}</p>
                                                            <p><strong>Provincia:</strong> {hojaCompleta.provincia}</p>
                                                            <p><strong>Cantón:</strong> {hojaCompleta.canton}</p>
                                                            <p><strong>Dirección:</strong> {hojaCompleta.direccion}</p>
                                                            <p><strong>Preferencia salarial:</strong> {hojaCompleta.preferencia_salarial}</p>
                                                        </div>
                                                    </div>
                                                    {(hojaCompleta.discapacidad || hojaCompleta.porcentaje_discapacidad) && (
                                                        <div className="row mt-2">
                                                            <div className="col-12">
                                                                <p><strong>Discapacidad:</strong> {hojaCompleta.discapacidad || 'No especificada'}</p>
                                                                {hojaCompleta.porcentaje_discapacidad && (
                                                                    <p><strong>Porcentaje de discapacidad:</strong> {hojaCompleta.porcentaje_discapacidad}%</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {hojaCompleta.formacionesAcademicas && hojaCompleta.formacionesAcademicas.length > 0 && (
                                                    <div className="mb-4">
                                                        <h5 className="border-bottom pb-2" style={{ color: "#004892" }}>
                                                            <i className="bi bi-book me-2"></i>
                                                            Formación Académica
                                                        </h5>
                                                        {hojaCompleta.formacionesAcademicas.map((formacion, index) => (
                                                            <div key={formacion.id} className="mb-3 p-3 border rounded">
                                                                <h6>Formación #{index + 1}</h6>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <p><strong>Título / Carrera:</strong> {formacion.titulo}</p>
                                                                        <p><strong>Tipo de estudio:</strong> {formacion.tipo_estudio}</p>
                                                                        <p><strong>Área de estudio:</strong> {formacion.area_estudio}</p>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <p><strong>Institución:</strong> {formacion.institucion}</p>
                                                                        <p><strong>Estado:</strong> {formacion.estado_estudio}</p>
                                                                        <p><strong>Período:</strong> {(formacion.fecha_inicio_estudio)} - {formacion.fecha_fin_estudio ? (formacion.fecha_fin_estudio) : 'Actual'}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                )}

                                                {hojaCompleta.idiomas && hojaCompleta.idiomas.length > 0 && (
                                                    <div className="mb-4">
                                                        <h5 className="border-bottom pb-2" style={{ color: "#004892" }}>
                                                            <i className="bi bi-translate me-2"></i>
                                                            Idiomas
                                                        </h5>
                                                        {hojaCompleta.idiomas.map((idioma, index) => (
                                                            <div key={idioma.id} className="mb-2 p-2 border rounded">
                                                                <h6><strong>IDIOMA:</strong>{idioma.idioma === 'Otros' ? idioma.otro_idioma : idioma.idioma}</h6>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <p><strong>Nivel escrito:</strong> {idioma.nivel_escrito || 'No especificado'}</p>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <p><strong>Nivel oral:</strong> {idioma.nivel_oral || 'No especificado'}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {hojaCompleta.experiencias && hojaCompleta.experiencias.length > 0 && (
                                                    <div className="mb-4">
                                                        <h5 className="border-bottom pb-2" style={{ color: "#004892" }}>
                                                            <i className="bi bi-briefcase me-2"></i>
                                                            Experiencia en Conduto
                                                        </h5>
                                                        <div className="mb-3 p-3 border rounded">
                                                            <p><strong>¿HA TRABAJADO EN CONDUTO ANTES?: </strong>{hojaCompleta.trabajado_conduto?.toUpperCase()}</p>
                                                        </div>
                                                        <h5 className="border-bottom pb-2" style={{ color: "#004892" }}>
                                                            <i className="bi bi-briefcase me-2"></i>
                                                            Experiencia Laboral
                                                        </h5>
                                                        {hojaCompleta.experiencias.map((experiencia, index) => (
                                                            <div key={experiencia.id} className="mb-3 p-3 border rounded">
                                                                <h6>Experiencia #{index + 1}</h6>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <p><strong>Empresa:</strong> {experiencia.empresa}</p>
                                                                        <p><strong>Actividad de la empresa:</strong> {experiencia.actividad_empresa}</p>
                                                                        <p><strong>Puesto:</strong> {experiencia.puesto === "Otros" ? experiencia.otro_puesto : experiencia.puesto}</p>
                                                                        <p><strong>Nivel de experiencia:</strong> {experiencia.nivel_experiencia}</p>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <p><strong>País:</strong> {experiencia.pais_empresa}</p>
                                                                        <p><strong>Período:</strong> {(experiencia.fecha_inicio_experiencia)} / {(experiencia.fecha_finalizacion_experiencia)}</p>
                                                                        {experiencia.personas_cargo && (
                                                                            <p><strong>Personas a cargo:</strong> {experiencia.personas_cargo}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="mt-2">
                                                                    <p><strong>Descripción de responsabilidades:</strong></p>
                                                                    <p className="p-2 bg-white border rounded">{experiencia.descripcion_responsabilidad}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                <div className="mb-3">
                                                    <h5 className="border-bottom pb-2" style={{ color: "#004892" }}>
                                                        <i className="bi bi-file-earmark me-2"></i>
                                                        Archivos
                                                    </h5>
                                                    {hojaCompleta.cv_filename && (
                                                        <button
                                                            className="btn btn-outline-primary"
                                                            onClick={() => descargarCV(hojaCompleta.cv_filename)}
                                                        >
                                                            <i className="bi bi-download me-2"></i>
                                                            Descargar CV - {hojaCompleta.cv_filename}
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="text-muted small">
                                                    <p><strong>Registrado:</strong> {new Date(hojaCompleta.fecha_creacion).toLocaleString('es-ES')}</p>
                                                </div>
                                            </div>
                                        )}

                                        {estaExpandida && !hojaCompleta && (
                                            <div className="mt-3 p-3 border rounded bg-light text-center">
                                                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                                                Cargando detalles...
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ListaHojasVida;